import { FounderQuote } from "@/components/FounderQuote";

export const GeoVsSeoFounderQuote = () => {
  return (
    <FounderQuote
      quote="We rebuilt our entire content strategy around GEO. The question isn't 'will Google rank this?'—it's 'will ChatGPT cite this as an authoritative source?' The tactics are different: structured data, FAQ schemas, definitive statements, and sources that LLMs can verify. This site you're reading was built with GEO-first principles."
      author="aman"
      tagline="Pioneering GEO strategies for SaaS and B2B content"
    />
  );
};